export const frontmatter = {
    "draft": false,
    "title": "Sistema de tickets",
    "sidebar_group": "referencia",
    "sidebar_label": "Sistema de tickets",
    "sidebar_order": 3
}

export const toc = []